"use client"

import { useState } from "react"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { useLanguage } from "@/contexts/language-context"

export function FAQ() {
  const { t } = useLanguage()
  const [openItem, setOpenItem] = useState<string | null>("item-1")

  const faqItems = [
    {
      id: "item-1",
      question: t("faq1Question"),
      answer: t("faq1Answer"),
    },
    {
      id: "item-2",
      question: t("faq2Question"),
      answer: t("faq2Answer"),
    },
    {
      id: "item-3",
      question: t("faq3Question"),
      answer: t("faq3Answer"),
    },
    {
      id: "item-4",
      question: t("faq4Question"),
      answer: t("faq4Answer"),
    },
    {
      id: "item-5",
      question: t("faq5Question"),
      answer: t("faq5Answer"),
    },
    {
      id: "item-6",
      question: t("faq6Question"),
      answer: t("faq6Answer"),
    },
    {
      id: "item-7",
      question: t("faq7Question"),
      answer: t("faq7Answer"),
    },
    {
      id: "item-8",
      question: t("faq8Question"),
      answer: t("faq8Answer"),
    },
  ]

  return (
    <section id="faq" className="w-full py-12 md:py-24 bg-[#1a1310]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">{t("faqTitle")}</h2>
            <p className="max-w-[900px] text-muted-foreground md:text-xl">{t("faqDesc")}</p>
          </div>
        </div>
        <div className="mx-auto max-w-3xl py-12">
          <Accordion
            type="single"
            collapsible
            value={openItem || undefined}
            onValueChange={(value) => setOpenItem(value)}
          >
            {faqItems.map((item) => (
              <AccordionItem key={item.id} value={item.id} className="border-b border-muted">
                <AccordionTrigger className="text-left">{item.question}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground">{item.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  )
}
